import { freddyTheme, mergeStyles, type SxProps } from '@coolblue-development/freddy';

const getButtonStyles = ({ next = false, show }: { next?: boolean; show?: boolean }): SxProps => {
  return mergeStyles([
    {
      position: 'absolute',
      top: 270, // account for height of the wideproductimage + wishlish and remove and buttons
      [next ? 'right' : 'left']: next
        ? 'calc(50vw - (64rem + var(--cb-spec-container-horizontal-padding) / 2))'
        : 'calc(50vw - (40rem + var(--cb-spec-container-horizontal-padding) / 2))',
      transition: 'transform .4s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      transform: show ? 'scale(1) translateX(0)' : `scale(0) translateX(${next ? '-50%' : '50%'})`,
      zIndex: 9,
      [freddyTheme.breakpoint.only('md')]: {
        transformOrigin: next ? 'right' : 'left',
        transform: show ? 'scale(1)' : `scale(0)`
      },
      [freddyTheme.breakpoint.maxWidth('lg')]: {
        position: 'fixed',
        right: next ? 0 : 'initial',
        left: !next ? '0 !important' : 'initial'
      },
      [freddyTheme.breakpoint.minWidth('lg') + ' and (max-width: 1330px)']: {
        left: next ? 'initial' : 'var(--comparison-column-width) !important',
        right: next ? freddyTheme.spacing[400] : 'initial'
      }
    }
  ]);
};

export default getButtonStyles;
